const playerCard = {
  playerCard: {
    accountStatus: 'Account Status',
    assignCoolOff: 'Assign cool by',
    blockedReasons: 'Blocked Reasons',
    coolOff: 'Cool Off',
    findPlayer: 'Find Player',
    kycStatus: 'KYC Status',
    limits: 'Limits',
    noPlayerIdData: 'Please try with another Player ID or Username',
    personalInformation: 'Personal Information',
    responsibleGaming: 'Responsible Gaming',
    selfExclusion: 'Self Exclusion',
    selfExclusionMessage:
      'By proceeding, the player will be temporarily or permanently excluded from accessing their account and participating in any casino activities.',
    sendNotification: 'Send notification email to client',
    manualDebitCredit: 'Manual Debit/Credit',
    credit: 'Credit',
    debit: 'Debit',
    currentBalance: 'Current Balance:',
    amountToBeAdded: 'Amount to be added:',
    amountToBeRemoved: 'Amount to be removed:',
    totalTokens: 'Total Tokens:',
    applyCredit: 'Apply Credit',
    applyDebit: 'Apply Debit',
  },
}

export default playerCard
